/* CUCU shared horizontal-rail controller.
   Owns every `.cu-rail` scroller in the theme.

   NOTE ON SCROLLING: this theme's page wrapper sets scroll-behavior:smooth,
   which in practice leaves native `scrollTo({behavior:'smooth'})` on these
   rails doing nothing at all (verified: scrollLeft stays 0, while a direct
   scrollLeft assignment works). So we animate the scroll ourselves with rAF
   and never depend on native smooth behaviour.

   Markup contract:
     <div class="cu-railnav" data-cu-railnav="RAIL_ID">
       <button data-cu-nav="prev" aria-controls="RAIL_ID">
       <button data-cu-nav="next" aria-controls="RAIL_ID">
     <div class="cu-rail" id="RAIL_ID" data-cu-rail> */
(function () {
  if (window.__cucuRail) { return; }
  window.__cucuRail = true;

  var EPS = 2;
  var DURATION = 380;

  function railFor(nav) {
    var id = nav.getAttribute('data-cu-railnav');
    return id ? document.getElementById(id) : null;
  }

  function sync(nav, rail) {
    var max = rail.scrollWidth - rail.clientWidth;
    var overflows = max > EPS;
    if (nav.classList.contains('is-on') !== overflows) {
      nav.classList.toggle('is-on', overflows);
    }
    nav.setAttribute('aria-hidden', overflows ? 'false' : 'true');
    var x = rail.scrollLeft;
    var prev = nav.querySelector('[data-cu-nav="prev"]');
    var next = nav.querySelector('[data-cu-nav="next"]');
    if (prev) { prev.disabled = !overflows || x <= EPS; }
    if (next) { next.disabled = !overflows || x >= max - EPS; }
  }

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Own tween: never relies on native smooth scrolling. */
  function tween(rail, target) {
    /* Hidden/background and prerendered tabs throttle rAF to a single frame, so
       an rAF tween would never reach its target there. Jump straight to it. */
    if (document.hidden) { rail.scrollLeft = target; return; }
    if (rail.__cucuAnim) { cancelAnimationFrame(rail.__cucuAnim); rail.__cucuAnim = null; }
    var start = rail.scrollLeft;
    var delta = target - start;
    if (Math.abs(delta) < 1) { return; }
    if (reduceMotion()) { rail.scrollLeft = target; return; }
    var t0 = null;
    function frame(ts) {
      if (t0 === null) { t0 = ts; }
      var p = Math.min(1, (ts - t0) / DURATION);
      /* easeOutCubic */
      var e = 1 - Math.pow(1 - p, 3);
      rail.scrollLeft = start + (delta * e);
      if (p < 1) {
        rail.__cucuAnim = requestAnimationFrame(frame);
      } else {
        rail.__cucuAnim = null;
        rail.scrollLeft = target;
      }
    }
    rail.__cucuAnim = requestAnimationFrame(frame);
  }

  function step(rail, dir) {
    var amount = Math.max(120, Math.round(rail.clientWidth * 0.9));
    var max = rail.scrollWidth - rail.clientWidth;
    var target = rail.scrollLeft + (dir * amount);
    if (target < 0) { target = 0; }
    if (target > max) { target = max; }
    tween(rail, target);
  }

  function bindNav(nav) {
    var rail = railFor(nav);
    if (!rail) { return; }
    if (!nav.__cucuBound) {
      nav.__cucuBound = true;
      nav.addEventListener('click', function (e) {
        var t = e.target;
        var btn = (t && t.closest) ? t.closest('[data-cu-nav]') : null;
        if (!btn || btn.disabled) { return; }
        e.preventDefault();
        step(rail, btn.getAttribute('data-cu-nav') === 'next' ? 1 : -1);
      });
      rail.addEventListener('scroll', function () { sync(nav, rail); }, { passive: true });
    }
    resetStart(rail);
    sync(nav, rail);
  }

  function resetStart(rail) {
    if (rail.__cucuReset) { return; }
    rail.__cucuReset = true;
    if (rail.scrollLeft !== 0) { rail.scrollLeft = 0; }
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var navs = root.querySelectorAll('[data-cu-railnav]');
    var i;
    for (i = 0; i < navs.length; i++) { bindNav(navs[i]); }
    var rails = root.querySelectorAll('[data-cu-rail]');
    for (i = 0; i < rails.length; i++) { resetStart(rails[i]); }
  }

  function syncAll() {
    var navs = document.querySelectorAll('[data-cu-railnav]');
    for (var i = 0; i < navs.length; i++) {
      var rail = railFor(navs[i]);
      if (rail) { sync(navs[i], rail); }
    }
  }

  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };

  function boot() {
    init(document);
    raf(function () { syncAll(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(syncAll, 120);
  });

  /* Images arriving late change scrollWidth, so re-evaluate overflow. */
  document.addEventListener('load', function (e) {
    if (e.target && e.target.tagName === 'IMG') { syncAll(); }
  }, true);

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
    raf(syncAll);
  });
})();